var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(tag){return _c('v-chip',{key:tag,staticClass:"mr-2 mb-2",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.tagNameFromHandle(tag))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }